import $ from 'jquery'
import 'slick-carousel'
import Vue from "vue"
import Quiz from './quiz/quiz'
import hljs from 'highlight.js';

export function initMarkup($container) {
  setupMarkupQuiz($container)
  markupVideoOverlay($container)
  initMarkupSlideshow($container)
  initHighlightjs()
}

function initMarkupSlideshow($container) {
  $container.find('.slideshow').slick({
    dots: true,
    infinite: true,
    adaptiveHeight: true
  });
}

function initHighlightjs() {
  hljs.initHighlighting.called = false; // to reinit plugin without page reloading
  hljs.initHighlighting();
}

function setupMarkupQuiz($section) {
  const quizzes = []

  $section.find(".quiz").replaceWith(function() {
    const $quiz = $(this)

    const dataText = $quiz[0].firstChild.data
    const quizResponse = JSON.parse(dataText)
    const questions = quizResponse.questions
    quizzes.push(questions)
    return $("<div class='m-quiz' />")
  })

  quizzes.forEach(questions => {
    const el = $section.find('.m-quiz').get(0)

    new Vue({
      el,
      render(h) {
        return h(Quiz, {
          props: { questions }
        })
      }
    })
  })
}

function markupVideoOverlay($mainContainer) {
  const $markupVideoLink = $('.markup-video-link', $mainContainer)

  $markupVideoLink.on('click', function () {
    const videoData = $(this).data("video-id"),
        $modal = $(".markup-video[id=" + videoData + "]");

    SOPHIA.videoJsPlayer($mainContainer);

    SOPHIA.overlayBox($modal, {
      afterClose: function() {
        $.fancybox.destroy();
      }
    });
  })
}
